(() => {
  const compareKey = 'cb-compare';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const normalize = (value = '') => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  const read = (name, fallback) => { try { return JSON.parse(localStorage.getItem(name)) ?? fallback; } catch (_) { return fallback; } };
  const write = (name, value) => { try { localStorage.setItem(name, JSON.stringify(value)); } catch (_) {} };
  let catalogPromise;


  function openDialog(id) { const dialog = document.getElementById(id); if (dialog && !dialog.open) dialog.showModal(); }
  function closeDialog(button) { button.closest('dialog')?.close(); }

  function titleInjectedFrames() {
    const titles = {
      PBarNextFrame: 'Shopify theme preview tools',
      merchantwidgetiframe: 'Google merchant shopping information'
    };
    Object.entries(titles).forEach(([id, title]) => {
      const frame = document.getElementById(id);
      if (frame && !frame.title) frame.title = title;
    });
  }

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
  const money = (cents) => Number.isFinite(Number(cents))
    ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Number(cents) / 100)
    : 'See product';
  const rawPrice = (formatted = '') => {
    const cleaned = String(formatted).replace(/[^0-9.,]/g, '').replace(/,/g, '').replace(/^[^0-9]+/, '');
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  };

  function itemFromCard(card) {
    return {
      handle: card.dataset.productHandle,
      title: card.dataset.productTitle,
      image: card.dataset.productImage,
      price: card.dataset.productPrice,
      priceRaw: Number(card.dataset.productPriceRaw) || rawPrice(card.dataset.productPrice),
      comparePriceRaw: Number(card.dataset.productComparePriceRaw) || 0,
      type: card.dataset.productType,
      tags: card.dataset.productTags,
      url: card.dataset.productUrl || `/products/${card.dataset.productHandle}`,
      variantId: card.dataset.productVariantId,
      available: card.dataset.productAvailable !== 'false',
      model: card.dataset.productModel,
      family: card.dataset.productFamily,
      material: card.dataset.productMaterial,
      magsafe: card.dataset.productMagsafe,
      grip: card.dataset.productGrip,
      camera: card.dataset.productCamera,
      protection: card.dataset.productProtection,
      profile: card.dataset.productProfile,
      controls: card.dataset.productControls,
      bestFor: card.dataset.productBestFor
    };
  }

  function itemFromCatalog(product) {
    const variant = product.variants?.find((entry) => entry.available) || product.variants?.[0] || {};
    return {
      handle: product.handle,
      title: product.title,
      image: product.images?.[0]?.src || '',
      priceRaw: Math.round(Number(variant.price || 0) * 100),
      comparePriceRaw: Math.round(Number(variant.compare_at_price || 0) * 100),
      type: product.product_type || '',
      tags: Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || ''),
      url: `/products/${product.handle}`,
      variantId: variant.id,
      available: Boolean(variant.available)
    };
  }

  function compareItems() {
    const unique = [];
    read(compareKey, []).forEach((item) => {
      if (item?.handle && !unique.some((saved) => saved.handle === item.handle) && unique.length < 3) unique.push(item);
    });
    return unique;
  }

  function ensureCompareButtons() {
    $$('.cb-card[data-product-handle]').forEach((card) => {
      if (card.dataset.compareEnabled === 'false') return;
      if ($('[data-compare-toggle]', card)) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cb-compare-toggle';
      button.dataset.compareToggle = card.dataset.productHandle;
      button.textContent = 'Compare';
      button.setAttribute('aria-label', `Compare ${card.dataset.productTitle}`);
      button.title = 'Add to comparison';
      const content = $('.cb-card__content', card);
      const form = $('.cb-card__form', card);
      if (content && form) content.insertBefore(button, form);
      else (content || card).appendChild(button);
    });
    updateCompareUI();
  }

  function updateCompareUI() {
    const items = compareItems();
    $$('[data-compare-toggle]').forEach((button) => {
      const selected = items.some((item) => item.handle === button.dataset.compareToggle);
      button.classList.toggle('is-selected', selected);
      button.textContent = selected ? 'Remove from compare' : 'Compare';
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? 'Remove' : 'Compare'} ${button.closest('.cb-card')?.dataset.productTitle || 'case'}`);
      button.title = selected ? 'Remove from comparison' : 'Add to comparison';
    });
    $('[data-compare-count]') && ($('[data-compare-count]').textContent = items.length);
    $('[data-compare-dock]')?.classList.toggle('is-visible', items.length > 0);
  }

  function toggleCompare(button) {
    const card = button.closest('.cb-card');
    let items = compareItems();
    const handle = card.dataset.productHandle;
    const existing = items.findIndex((item) => item.handle === handle);
    if (existing >= 0) items.splice(existing, 1);
    else if (items.length < 3) items.push(itemFromCard(card));
    else { button.textContent = 'Maximum 3'; window.setTimeout(updateCompareUI, 1200); return; }
    write(compareKey, items);
    updateCompareUI();
  }

  function productFamily(item) {
    if (item.family) return item.family;
    const text = normalize(`${item.title} ${item.type} ${item.tags}`);
    if (text.includes('luxuryleather')) return 'Luxury Leather';
    if (text.includes('ribbed')) return 'Ribbed MagSafe';
    if (text.includes('gradient')) return 'Gradient MagSafe';
    if (text.includes('antiyellow') || text.includes('clearcase')) return 'Anti-Yellow Clear';
    if (text.includes('leather')) return 'Leather Classic';
    return item.type || 'CaseBear Case';
  }

  function productDevice(item) {
    if (item.model && item.model !== 'For Selected Device') return item.model.replace(/^For\s+/i, '');
    let detail = String(item.title || '').split(/\s+for\s+/i)[1] || '';
    detail = detail.replace(/\s+(?:with\s+)?sensor\s+flash\s+guard.*$/i, '');
    const colours = ['Cosmic Orange', 'Midnight Black', 'Classic Brown', 'Royal Gold', 'Deep Blue', 'Space Grey', 'Space Gray', 'Silver', 'White', 'Orange', 'Blue', 'Black', 'Grey', 'Gray', 'Green', 'Brown'];
    colours.some((colour) => {
      const expression = new RegExp(`\\s+${colour}$`, 'i');
      if (!expression.test(detail)) return false;
      detail = detail.replace(expression, '');
      return true;
    });
    return detail.trim() || 'Confirm on product page';
  }

  function productColour(item, family) {
    const colours = ['Cosmic Orange', 'Midnight Black', 'Classic Brown', 'Royal Gold', 'Deep Blue', 'Space Grey', 'Space Gray', 'Silver', 'White', 'Orange', 'Blue', 'Black', 'Grey', 'Gray', 'Green', 'Brown'];
    const colour = colours.find((entry) => new RegExp(`\\b${entry}\\b`, 'i').test(item.title || ''));
    if (colour) return colour;
    if (family === 'Anti-Yellow Clear') return 'Clear';
    if (family.includes('Gradient')) return 'Gradient finish';
    if (family.includes('Leather')) return 'Leather finish';
    return 'See product gallery';
  }

  function productSpecs(item) {
    const family = productFamily(item);
    const text = normalize(`${item.title} ${item.type} ${item.tags}`);
    const isAntiYellow = family === 'Anti-Yellow Clear';
    const isLuxury = family === 'Luxury Leather';
    const isLeather = family === 'Leather Classic';
    const isRibbed = family === 'Ribbed MagSafe';
    const isGradient = family === 'Gradient MagSafe';
    const price = Number(item.priceRaw) || rawPrice(item.price);
    const comparePrice = Number(item.comparePriceRaw) || 0;
    const saving = comparePrice > price ? comparePrice - price : 0;
    return {
      family,
      device: productDevice(item),
      finish: productColour(item, family),
      material: item.material || (isAntiYellow ? 'Clear TPU and polycarbonate' : isLuxury ? 'Leather-textured protective shell' : isLeather ? 'Leather-finish protective shell' : isRibbed ? 'Textured protective polymer' : isGradient ? 'Translucent gradient polymer' : 'Protective phone-case material'),
      magsafe: item.magsafe || ((isAntiYellow || isRibbed || isGradient || text.includes('magsafe')) ? 'MagSafe compatible' : 'Not specified'),
      grip: item.grip || (isRibbed ? 'High-grip ribbed texture' : isLuxury ? 'Soft leather-textured grip' : isLeather ? 'Smooth leather-finish grip' : isGradient ? 'Smooth gradient finish' : isAntiYellow ? 'Clear secure-grip frame' : 'Smooth everyday grip'),
      camera: item.camera || (text.includes('sensorflashguard') ? 'Integrated sensor flash guard' : isLuxury ? 'Raised camera surround' : 'Raised camera edge'),
      protection: item.protection || (isRibbed ? 'Shock-absorbing ribbed shell' : isGradient ? 'Shock-absorbing protective shell' : isAntiYellow ? 'Shock-absorbing clear shell' : 'Everyday edge and corner protection'),
      profile: item.profile || 'Slim profile',
      controls: item.controls || ((isLuxury || isLeather) ? 'Precision metal buttons' : 'Covered responsive controls'),
      bestFor: item.bestFor || (isRibbed ? 'Maximum grip and impact protection' : isGradient ? 'MagSafe and translucent colour' : isAntiYellow ? 'Clarity and everyday protection' : isLuxury ? 'Premium feel and refined styling' : isLeather ? 'Slim professional styling' : 'Everyday protection'),
      price,
      comparePrice,
      saving,
      savingPercent: saving && comparePrice ? Math.round((saving / comparePrice) * 100) : 0,
      available: item.available !== false && item.available !== 'false'
    };
  }

  async function renderComparison() {
    let items = compareItems();
    const result = $('[data-compare-results]');
    if (!result) return;
    if (!items.length) {
      result.innerHTML = '<div class="cb-compare-empty"><h3>No cases selected</h3><p>Choose up to three cases from any product collection.</p></div>';
      openDialog('CbCompareDialog');
      return;
    }
    if (items.some((item) => !item.priceRaw || !item.variantId || !item.family)) {
      result.innerHTML = '<div class="cb-compare-empty"><p>Refreshing current product details...</p></div>';
      openDialog('CbCompareDialog');
      const products = await getCatalog();
      items = items.map((item) => {
        const product = products.find((entry) => entry.handle === item.handle);
        return product ? { ...item, ...itemFromCatalog(product), image: item.image || product.images?.[0]?.src || '' } : item;
      });
      write(compareKey, items);
    }
    const specs = items.map(productSpecs);
    const values = (label, getter) => `<tr><th scope="row">${label}</th>${items.map((item, index) => `<td>${getter(specs[index], item)}</td>`).join('')}</tr>`;
    const productCell = (item) => `<div class="cb-compare-product">
      <a href="${escapeHTML(item.url || `/products/${item.handle}`)}"><img src="${escapeHTML(item.image)}" alt=""><strong>${escapeHTML(item.title)}</strong></a>
      <div class="cb-compare-product__actions"><button class="cb-compare-action" type="button" data-compare-replace="${escapeHTML(item.handle)}">Replace</button><button class="cb-compare-action" type="button" data-compare-remove="${escapeHTML(item.handle)}">Remove</button></div>
    </div>`;
    const priceCell = (spec) => `<div class="cb-compare-price"><strong>${money(spec.price)}</strong>${spec.comparePrice > spec.price ? `<s>MRP ${money(spec.comparePrice)}</s><span class="cb-compare-saving">Save ${money(spec.saving)} (${spec.savingPercent}%)</span>` : ''}</div>`;
    const shopCell = (spec, item) => `<div class="cb-compare-shop-actions"><a class="cb-compare-action" href="${escapeHTML(item.url || `/products/${item.handle}`)}">View case</a>${item.variantId && spec.available ? `<form method="post" action="/cart/add"><input type="hidden" name="id" value="${escapeHTML(item.variantId)}"><button class="cb-compare-action cb-compare-action--primary" type="submit">Add to cart</button></form>` : ''}</div>`;
    const mobileRow = (label, value) => `<div><dt>${label}</dt><dd>${value}</dd></div>`;
    const mobileCard = (spec, item) => `<article class="cb-compare-mobile-card">
      <div class="cb-compare-mobile-card__head"><a href="${escapeHTML(item.url || `/products/${item.handle}`)}"><img src="${escapeHTML(item.image)}" alt=""></a><div><strong>${escapeHTML(item.title)}</strong><div class="cb-compare-product__actions"><button class="cb-compare-action" type="button" data-compare-replace="${escapeHTML(item.handle)}">Replace</button><button class="cb-compare-action" type="button" data-compare-remove="${escapeHTML(item.handle)}">Remove</button></div></div></div>
      <dl class="cb-compare-mobile-specs">
        ${mobileRow('Price', priceCell(spec))}
        ${mobileRow('Best for', escapeHTML(spec.bestFor))}
        ${mobileRow('Device', escapeHTML(spec.device))}
        ${mobileRow('Case family', escapeHTML(spec.family))}
        ${mobileRow('Finish', escapeHTML(spec.finish))}
        ${mobileRow('Material', escapeHTML(spec.material))}
        ${mobileRow('MagSafe', escapeHTML(spec.magsafe))}
        ${mobileRow('Grip', escapeHTML(spec.grip))}
        ${mobileRow('Camera', escapeHTML(spec.camera))}
        ${mobileRow('Protection', escapeHTML(spec.protection))}
        ${mobileRow('Profile', escapeHTML(spec.profile))}
        ${mobileRow('Buttons', escapeHTML(spec.controls))}
        ${mobileRow('Availability', `<span class="cb-compare-status${spec.available ? '' : ' is-unavailable'}">${spec.available ? 'In stock' : 'Sold out'}</span>`)}
      </dl>
      <div class="cb-compare-mobile-card__shop">${shopCell(spec, item)}</div>
    </article>`;
    result.innerHTML = `<div class="cb-compare-toolbar"><p>${items.length} of 3 cases selected. Scroll sideways to compare every detail.</p><button class="cb-compare-clear" type="button" data-compare-clear>Clear all</button></div>
      <div data-compare-replace-panel></div>
      <div class="cb-compare-mobile" aria-label="Selected case comparisons">${items.map((item, index) => mobileCard(specs[index], item)).join('')}</div>
      <table class="cb-compare-table"><tbody>
        ${values('Case', (_spec, item) => productCell(item))}
        ${values('Price', (spec) => priceCell(spec))}
        ${values('Best for', (spec) => escapeHTML(spec.bestFor))}
        ${values('Device', (spec) => escapeHTML(spec.device))}
        ${values('Case family', (spec) => escapeHTML(spec.family))}
        ${values('Colour / finish', (spec) => escapeHTML(spec.finish))}
        ${values('Material', (spec) => escapeHTML(spec.material))}
        ${values('MagSafe', (spec) => escapeHTML(spec.magsafe))}
        ${values('Grip', (spec) => escapeHTML(spec.grip))}
        ${values('Camera protection', (spec) => escapeHTML(spec.camera))}
        ${values('Protection', (spec) => escapeHTML(spec.protection))}
        ${values('Profile', (spec) => escapeHTML(spec.profile))}
        ${values('Buttons', (spec) => escapeHTML(spec.controls))}
        ${values('Availability', (spec) => `<span class="cb-compare-status${spec.available ? '' : ' is-unavailable'}">${spec.available ? 'In stock' : 'Sold out'}</span>`)}
        ${values('Shop', (spec, item) => shopCell(spec, item))}
      </tbody></table>`;
    openDialog('CbCompareDialog');
  }

  function removeComparison(handle) {
    write(compareKey, compareItems().filter((item) => item.handle !== handle));
    updateCompareUI();
    renderComparison();
  }

  function replacementResults(products, query = '') {
    const panel = $('[data-compare-replace-panel]');
    if (!panel) return;
    const selected = new Set(compareItems().map((item) => item.handle));
    const needle = normalize(query);
    const matches = products.filter((product) => !selected.has(product.handle) && product.variants?.some((variant) => variant.available) && (!needle || normalize(`${product.title} ${product.tags} ${product.product_type}`).includes(needle)))
      .slice(0, 12);
    const results = $('[data-compare-replace-results]', panel);
    if (!results) return;
    results.innerHTML = matches.length ? matches.map((product) => {
      const item = itemFromCatalog(product);
      return `<button class="cb-compare-replacement" type="button" data-compare-replacement="${escapeHTML(product.handle)}"><strong>${escapeHTML(product.title)}</strong><span>${money(item.priceRaw)}</span></button>`;
    }).join('') : '<p>No in-stock cases match that search.</p>';
  }

  async function openReplacementPicker(handle) {
    const panel = $('[data-compare-replace-panel]');
    if (!panel) return;
    const current = compareItems().find((item) => item.handle === handle);
    panel.dataset.replacingHandle = handle;
    panel.innerHTML = `<div class="cb-compare-replace"><div class="cb-compare-replace__head"><h3>Replace ${escapeHTML(current?.title || 'case')}</h3><button class="cb-compare-action" type="button" data-close-replace>Cancel</button></div><label><span class="visually-hidden">Search replacement cases</span><input type="search" placeholder="Search by device, family or colour" data-compare-replace-search></label><div class="cb-compare-replace__results" data-compare-replace-results><p>Loading in-stock cases...</p></div></div>`;
    const products = await getCatalog();
    replacementResults(products);
    $('[data-compare-replace-search]', panel)?.focus();
  }

  async function replaceComparison(handle) {
    const panel = $('[data-compare-replace-panel]');
    const replacingHandle = panel?.dataset.replacingHandle;
    if (!replacingHandle) return;
    const products = await getCatalog();
    const product = products.find((entry) => entry.handle === handle);
    if (!product) return;
    const items = compareItems();
    const index = items.findIndex((item) => item.handle === replacingHandle);
    if (index < 0) return;
    items[index] = itemFromCatalog(product);
    write(compareKey, items);
    updateCompareUI();
    renderComparison();
  }

  async function getCatalog() {
    if (!catalogPromise) catalogPromise = fetch('/products.json?limit=250').then((response) => response.json()).then((data) => data.products || []);
    return catalogPromise;
  }



  document.addEventListener('click', async (event) => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-close-dialog]')) closeDialog(target);
    if (target.matches('[data-compare-toggle]')) toggleCompare(target);
    if (target.matches('[data-open-compare]')) renderComparison();
    if (target.matches('[data-compare-remove]')) removeComparison(target.dataset.compareRemove);
    if (target.matches('[data-compare-replace]')) openReplacementPicker(target.dataset.compareReplace);
    if (target.matches('[data-compare-replacement]')) replaceComparison(target.dataset.compareReplacement);
    if (target.matches('[data-close-replace]')) { const panel = target.closest('[data-compare-replace-panel]'); if (panel) panel.innerHTML = ''; }
    if (target.matches('[data-compare-clear]')) { write(compareKey, []); updateCompareUI(); renderComparison(); }
  });

  document.addEventListener('input', async (event) => {
    if (!event.target.matches('[data-compare-replace-search]')) return;
    replacementResults(await getCatalog(), event.target.value);
  });

  document.addEventListener('DOMContentLoaded', () => {
        ensureCompareButtons();

    titleInjectedFrames();
    const frameObserver = new MutationObserver(titleInjectedFrames);
    frameObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => frameObserver.disconnect(), 10000);
  });
  document.addEventListener('shopify:section:load', ensureCompareButtons);
})();
